<template>
  <section>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

      <!-- Dialog start -->

    <v-dialog
      v-model="dialog.loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.delete"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline">You Sure, about deleting this Action?</v-card-title>

        <v-card-text>
          Are you sure, you want to delete this action? <br/> We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="dialog.delete = false"
          >
            Don't Delete
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            @click="deleteAction"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.update" persistent v-if="dialog.hasLoaded" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Update this Action!
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
              v-model="form.name"
              label="Name"
              :rules="nameRules"
            ></v-text-field>
            <v-autocomplete
              :loading="autoCompleteLoading"
              :items="resources"
              item-text="name"
              flat
              label="RESOURCE"
              :rules="resourceRules"
              v-model="form.resource"
              :search-input.sync="search"
              clearable
              persistent-hint
              allow-overflow
              return-object
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            flat="flat"
            @click="dialog.update = false"
          >
            Don't Update
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            :disabled="!valid"
            @click="updateAction"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <!-- Dialog end -->
      <v-alert
        :value="err"
        type="error"
        v-if="err"
      >
        {{ err.graphQLErrors.length > 0 ? err.graphQLErrors[0].data.message : err.message }}
      </v-alert>

      <div class="act--view-main" v-if="err">
        <section>
          <v-card class="act--view-card">
            <h2 style="font-size: 50px;">
              {{ err.graphQLErrors.length > 0 ? err.graphQLErrors[0].data.message : err.message }}
            </h2>
          </v-card>
        </section>
      </div>

    <div class="act--view-main">
      <section>
        <v-card class="act--view-card" style="min-height: 160px;" v-if="!err">
          <p class="act--view-title">ACTION</p>
          <div class="act--view-grid-call">
            <div>
              <p class="act--view-detail-title">ID: {{ this.action.id}}</p>
              <p class="act--view-detail-title">NAME: {{ this.action.name}}</p>
              <p class="act--view-detail-title">RESOURCE: {{ this.action.resource.name }}</p>
            </div>
          </div>
        </v-card>
        <v-card class="act--view-card" v-if="!err">
          <p class="act--view-title">Actions</p>
          <div class="act--view-grid-call-comment">
            <v-btn color="info" @click="moveTo(`/authentication/action/${action.id}?update=1`)">UPDATE</v-btn>
            <v-btn color="error" @click="moveTo(`/authentication/action/${action.id}?delete=1`)">DELETE</v-btn>
          </div>
        </v-card>
      </section>
    </div>
  </section>
</template>
<script>
import { coreClient } from "../../../apollo";
import gql from "graphql-tag";

export default {
  data() {
    return {
      action: {
        id: "",
        name: "",
        resource: {}
      },
      err: "",
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      dialog: {
        loading: false,
        hasLoaded: false,
        delete: false,
        update: false
      },
      form: {
        id: "",
        name: "",
        resource: {}
      },
      valid: false,
      nameRules: [
        v => !!v || "The name wasn't found.",
        v => v.length > 2 || "The name must be longer than 2 characters."
      ],
      resourceRules: [v => !!v || "The resource is required."],
      autoCompleteLoading: false,
      resources: [],
      search: null
    };
  },
  watch: {
    async search(v) {
      if (!v) {
        this.form.resource = "";
        await this.getResources();
        return;
      }

      this.loading = true;
      v && v !== this.form.resource && (await this.getResources({ name: v }));
      this.loading = false;
    }
  },
  methods: {
    async getAction(id) {
      this.dialog.loading = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Action($id: String!) {
              Action(id: $id) {
                id
                name
                resource {
                  id
                  name
                }
              }
            }
          `,
          variables: { id },
          fetchPolicy: "no-cache"
        });

        this.action = data.Action;
        this.form = { ...this.action };
      } catch (e) {
        this.snackbar = {
          show: true,
          text: e.graphQLErrors[0].data.message,
          color: "error"
        };
        this.err = e;
      }

      this.dialog.loading = false;
      this.dialog.hasLoaded = true;
    },
    async updateAction() {
      this.dialog.loading = true;
      let variables = {};
      Object.keys(this.form).forEach(field => {
        if (this.action[field] !== this.form[field]) {
          variables[field] = this.form[field];
        }
      });
      variables["id"] = this.action["id"];
      variables["name"] = variables["name"] || "";

      if (variables.resource) {
        variables.resource = variables.resource.id;
      }

      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateAction(
              $id: String!
              $name: String
              $resource: String
            ) {
              updateAction(id: $id, name: $name, resource: $resource) {
                id
                name
                resource {
                  id
                  name
                }
              }
            }
          `,
          variables
        });

        this.action = data.updateAction;
        this.snackbar = {
          text: "The action was updated!",
          color: "success",
          show: true
        };
        this.dialog.update = false;
        this.$router.push("/authentication/action/" + this.action.id);
      } catch (e) {
        console.log(e);
        this.snackbar = {
          show: true,
          text:
            e.graphQLErrors.length > 0
              ? e.graphQLErrors[0].data.message
              : e.message,
          color: "error"
        };
      }

      this.dialog.loading = false;
    },
    async deleteAction() {
      try {
      } catch (e) {}
    },
    async getResources(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Resources($name: String, $page: Int) {
              Resources(name: $name, page: $page) {
                total
                pages
                page
                docs {
                  id
                  name
                }
              }
            }
          `,
          variables
        });
        this.resources = data.Resources.docs;
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }
    },
    moveTo(uri) {
      this.$router.push(uri);
      this.$router.go();
    }
  },
  async mounted() {
    await this.getResources();
    await this.getAction(this.$route.params.id);
    let { query } = this.$route;

    if (query.update && query.delete) {
      return;
    }

    if (query.update) {
      this.dialog.update = true;
      return;
    }

    if (query.delete) {
      this.dialog.delete = true;
      return;
    }

    return;
  }
};
</script>
<style lang="stylus" scoped>
@import '../../../assets/stylus/Activities_view.styl';
</style>
